<template>
	<v-col class="text-center" cols='12' md='6'>
		<div class="viewer" ref="cesiumContainer">
			<vc-viewer
				:contextOptions="{
					backgroundColor: 'transparent',
					webgl: {
						alpha: true,
					},
				}"
				:logo="false"
				:timeline="false"
				@postRender="spinGlobe"
				ref="vcViewer"
				scene3DOnly
				shouldAnimate
			>
				<vc-layer-imagery alpha="1" brightness="1" contrast="1" ref="wms">
					<vc-provider-imagery-wms
						layers="coverage"
						:parameters="{ format: 'image/png' }"
						url="https://primar.ecc.no/primar/wms_ip/anonymous"
					/>
				</vc-layer-imagery>
			</vc-viewer>
		</div>
		<span class="mb-0 overline white--text" style="margin-top: -20px">
			Global ENC Coverage
		</span>
	</v-col>
</template>

<script>
import Vue from 'vue'
import VueCesium from 'vue-cesium'
Vue.use(VueCesium, { cesiumPath: '/Cesium/Cesium.js' })

export default {
	data() {
		return {
			rotationTime: Date.now(),
		}
	},
	mounted() {
		this.$refs.wms.createPromise.then((instance) => {
			const { Cesium, viewer } = instance
			const { scene, camera, clock } = viewer

			// Bind the Cesium instance to window object, so it is accessible everywhere
			window.cesiumInstance = instance

			instance.contextOptions = {
				powerPreference: 'low-power',
				allowTextureFilterAnisotropic: false,
			}

			viewer.powerPreference = 'low-power'
			viewer.scene3DOnly = true

			// Remove glow from globe as it is ugly with transparent bg
			scene.skyBox.show = false
			scene.skyAtmosphere.show = false
			scene.fog.enabled = false
			scene.shadows = false
			scene.globe.showGroundAtmosphere = false
			scene.backgroundColor = Cesium.Color.TRANSPARENT
			scene.highDynamicRange = false
			scene.light.intensity = 0
			scene.sun.show = false

			scene.screenSpaceCameraController.enableZoom = false;

			clock.multiplier = 30 * 60
		})
	},
	methods: {
		spinGlobe(scene, time) {
			const { Cesium, viewer } = window.cesiumInstance
			const { Cartesian3, Matrix4, Transforms } = Cesium
			const { camera } = viewer

			var icrfToFixed = Transforms.computeIcrfToFixedMatrix(time)
			if (Cesium.defined(icrfToFixed)) {
				const offset = Cartesian3.clone(camera.position)
				const transform = Matrix4.fromRotationTranslation(icrfToFixed)
				camera.lookAtTransform(transform, offset)
			}
		},
	},
}
</script>

<style lang='scss' >
.viewer{
	height: 100%;
}	
.cesium-viewer{
	height: 100%
}
.cesium-infoBox-camera{
	display: none !important;
}
</style>
